import { Color } from "theme/colors";

interface CheckProps {
  className?: string;
  fill: Color | string;
}

export const CheckCircle = ({ className, fill }: CheckProps) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M8.99935 0.666687C4.39935 0.666687 0.666016 4.40002 0.666016 9.00002C0.666016 13.6 4.39935 17.3334 8.99935 17.3334C13.5993 17.3334 17.3327 13.6 17.3327 9.00002C17.3327 4.40002 13.5993 0.666687 8.99935 0.666687ZM8.99935 15.6667C5.32435 15.6667 2.33268 12.675 2.33268 9.00002C2.33268 5.32502 5.32435 2.33335 8.99935 2.33335C12.6743 2.33335 15.666 5.32502 15.666 9.00002C15.666 12.675 12.6743 15.6667 8.99935 15.6667ZM12.8243 5.31669L7.33268 10.8084L5.17435 8.65835L3.99935 9.83335L7.33268 13.1667L13.9993 6.50002L12.8243 5.31669Z"
      fill={fill}
    />
  </svg>
);
